import { Fragment, FunctionalComponent} from 'preact';
import { useSelector } from 'react-redux';

import { selectTotalCounter } from '../../../totalCounter/slice';

import styles from './styles.module.scss';

const textStyles =
  typeof window === 'undefined' ? { color: 'transparent' } : {};

const formatCommunityCount = (num: number): string => {
  if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
  if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
  return num.toLocaleString();
};

const Counter: FunctionalComponent = () => {
  const totalCounter = useSelector(selectTotalCounter);
  const communityBottles = formatCommunityCount(Math.floor((totalCounter?.total || 0) / 5));

  return (
    <Fragment>
      <div
        className={`${styles.counterOuter} ${styles.bottlesCounter} bottlesCounterTC`}
      >
        <Fragment>
          <div className={`${styles.counter}`}>
            <div className={`${styles.counterIcon} ${styles.bottle}`} />
            <span style={textStyles}>{communityBottles} bottles saved</span>
          </div>
        </Fragment>
      </div>
    </Fragment>
  );
};

export default Counter;
